import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { FAQListItem } from "../../content.types";
import { requestFaqItems } from "./faqItems.request";

const useFaqItems = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<FAQListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const queryClient = useQueryClient();
  const queryKey = ["content-faq", "all", requestParams];

  const { data, ...rest } = useQuery({
    queryKey,
    queryFn: async () => await requestFaqItems(requestParams),
    onError: toastServerError,
    ...options
  });

  const setFaqItems = (newItems: FAQListItem[]) => {
    queryClient.setQueriesData(queryKey, {
      data: newItems,
      meta: data?.meta
    });
  };

  return { faqItems: data?.data, meta: data?.meta, setFaqItems, ...rest };
};

export default useFaqItems;
